/**
 * Helpers shared by the Dispatch scope summary card and its hover details.
 */

import {
  firstForemanFromAssignment,
  getWorkerRoleColorClass,
  parseHexFromTailwindBgClass,
} from "../../../../utils/business";

/** Highlight color when the scope's foreman has no role color (teal-600). */
export const DEFAULT_BLOCK_HIGHLIGHT_HEX = "#059669";

/**
 * Schedule-block highlight color for a Dispatch scope row, derived from the
 * linked block's default crew foreman so it matches the Schedule bar color
 * (per-day crews can diverge), falling back to teal-600. The day crew is used
 * if the payload predates the block crew being serialized.
 *
 * @param {Object} scope WorkScopeAspect row with `schedule_block`.
 * @returns {string} `#RRGGBB` hex color.
 */
export function getScopeBlockHighlightHex(scope) {
  const crew =
    scope?.schedule_block?.worker_assignment ?? scope?.worker_assignment;
  const foreman = firstForemanFromAssignment(crew);
  // Dark role palette reads better against the gray scope cards.
  const roleClass = getWorkerRoleColorClass(foreman, undefined, true);
  return parseHexFromTailwindBgClass(roleClass) ?? DEFAULT_BLOCK_HIGHLIGHT_HEX;
}
